module.exports = __webpack_public_path__ + "static/media/DSC00080.03686143.jpg";